// @flow

import type {Reducer} from '@travel-frontend/state-handling-sdk';
import type {PaymentTravelState} from 'redux/v1/paymentTravel/PaymentTravelState';

import {combineReducers} from 'redux';

import {ccReducer} from 'redux/v1/paymentTravel/cc/reducer';
import {deleteReducer} from 'redux/v1/paymentTravel/delete/reducer';
import {deletePaypalReducer} from 'redux/v1/paymentTravel/deletePaypal/reducer';
import {iframeReducer} from 'redux/v1/paymentTravel/iframe/reducer';
import {invoiceReducer} from 'redux/v1/paymentTravel/invoice/reducer';
import {paymentTypesReducer} from 'redux/v1/paymentTravel/paymentTypes/reducer';
import {paypalReducer} from 'redux/v1/paymentTravel/paypal/reducer';
import {paypalVaultReducer} from 'redux/v1/paymentTravel/paypalVault/reducer';
import {selectedPaymentReducer} from 'redux/v1/paymentTravel/selectedPayment/reducer';
import {sepaReducer} from 'redux/v1/paymentTravel/sepa/reducer';

export const paymentTravelReducer: Reducer<PaymentTravelState> =
  combineReducers({
    invoice: invoiceReducer,
    paymentTypes: paymentTypesReducer,
    cc: ccReducer,
    selectedPayment: selectedPaymentReducer,
    iframe: iframeReducer,
    sepa: sepaReducer,
    paypal: paypalReducer,
    deletePaypal: deletePaypalReducer,
    paypalVault: paypalVaultReducer,
    delete: deleteReducer,
  });
